// Copyright (c) Microsoft Corporation and others. Licensed under the MIT license.
// SPDX-License-Identifier: MIT
import React from 'react'

const LabelRenderer = ({ text }) => <span>{text}</span>
export default LabelRenderer
